import { render, staticRenderFns } from "./SntTextHighlight.vue?vue&type=template&id=6b856abd&scoped=true&"
import script from "./SntTextHighlight.vue?vue&type=script&lang=js&"
export * from "./SntTextHighlight.vue?vue&type=script&lang=js&"
import style0 from "./SntTextHighlight.vue?vue&type=style&index=0&id=6b856abd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b856abd",
  null
  
)

export default component.exports